import React, { Component } from 'react';
import FeedbackOption from  "./feedbackOption";
import RatingDom from  "./ratingDom";
import HttpUtils from '../../utils/http';
import Api from '../../utils/api';
import {Loader } from 'semantic-ui-react'
export default class ReviewDomItem extends Component {
	constructor(props) {
    super(props);
    this.updateRating = this.updateRating.bind(this);
    this.submitReviewLabelData = this.submitReviewLabelData.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

		this.state = {
      userId: localStorage.getItem("user_id"),
      productId: this.props.product.id ,
      rating: 0,
      productFeedbackImageUrls:[],  //图片的url，先上传
      comment: '',                  //评论
      productFeedbackOptionIds:[], //Less oily, Brighter 这些 tag 在数据库里的 id
      shareAge: this.props.shareAge,
      shareEthnicity: this.props.shareEthnicity,
      showImg: '',
      isLoader:false,
    };
  }

  updateRating(value) {
		this.setState({ rating: value,productFeedbackOptionIds:[]});
  }
  
  submitReviewLabelData(id){
    var feedbackOptionArray = this.state.productFeedbackOptionIds;
    
    if(feedbackOptionArray.indexOf(id) == -1){
      feedbackOptionArray.push(id)
    }else{
      feedbackOptionArray.splice(feedbackOptionArray.indexOf(id),1)
    }
    this.setState({
      productFeedbackOptionIds:feedbackOptionArray
    })
  }

  // 提交客户的隐私管理
  handleSubmitShareYour(){
    if(this.state.productFeedbackOptionIds.length >= 1 || this.state.comment !='' ){
      if(this.props.isfeedbackSettings){
        return HttpUtils.put("/api/product-feedback-settings",{
          userId: this.state.userId * 1,
          shareAge: this.props.shareAge,
          shareEthnicity: this.props.shareEthnicity,
          id: this.props.feedbackSettingsId,
        })
      }else{
        return HttpUtils.post("/api/product-feedback-settings",{
          userId: this.state.userId * 1,
          shareAge: this.props.shareAge,
          shareEthnicity: this.props.shareEthnicity,
        })
      }
     
    }
  }

  // 提交评论
  handleSubmitReview(){
    
    if(this.state.isLoader == true){
      return false;
    }
    
    if(this.state.productFeedbackOptionIds.length >= 1 || this.state.comment !='' || this.state.rating >0 ){
      this.setState({
        isLoader:true
      })
      HttpUtils.post("/api/product-reviews",{
        comment: this.state.comment,
        productFeedbackImageUrls: this.state.productFeedbackImageUrls,
        productFeedbackOptionIds: this.state.productFeedbackOptionIds,
        productId: this.state.productId,
        rating: this.state.rating,
        userId: this.state.userId
      }).then(response =>{
        this.setState({
          isLoader:false
        })
        if(this.props.index == (this.props.dataLength-1)){
          this.handleSubmitShareYour().then(()=>{
            this.props.closeReviewModal()
          })
        }else{
          this.handleSubmitShareYour()
          this.props.nextProduct()
        }

      }).catch(err =>{
        this.setState({
          isLoader:false
        })
        if(this.props.index == (this.props.dataLength-1)){
          this.props.closeReviewModal()
        }
        console.log(err)
      })
    }else{
      this.props.nextProduct()
      if(this.props.index == (this.props.dataLength-1)){
        this.props.closeReviewModal()
      }
    }
  }
  
  handleInputChange(event){
		const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
 
    this.setState({
      [name]: value
    });
  }

  handleGetImgUploadSrc(event){
    const fileData = [...event.target.files];
    if (fileData.length === 0) return;

    const formatReg = /\.(jpg|jpeg|png|gif)$/i
    if (fileData[0].size / 1024 / 1024 > 1) {
      alert('Photo size is too big. Please re-upload (max size = 1M)', 3)
      return
    }

    if (fileData[0].name.search(formatReg) === -1) {
      alert('Please select the correct file type', 3)
      return
    }

    var windowURL = window.URL || window.webkitURL;
    var dataURL = windowURL.createObjectURL(fileData[0]);
    this.setState({showImg:dataURL})
    var _this = this
    if(fileData[0]){
      var reader = new FileReader();  //本地预览
      reader.readAsDataURL(fileData[0]);
      reader.onloadend = function () { //图片转换为base64
        // var base64Data = reader.result.replace(/^data:image\/\w+;base64,/, "");
        _this.setState({
            imgSrc: reader.result
          },()=>{
            _this.handleComplete(reader.result);
          })
      }

    }else{
      this.setState({
        imgSrc: ''
      })
    }
  }
  
  handleComplete(imgBse64) {
		let filename = Api.getUUID()  + '.jpg';
    const bucket =  process.env.REACT_APP_S3_BUCKET_REVIEW_MODULE; 
    Api.s3ImageUpload(imgBse64, filename, 'image/jpeg', bucket);
    
    let imageUrlPrefix = 'https://helloava-prod.s3.us-east-2.amazonaws.com/product-feedback/';
    if (process.env.REACT_APP_ENV === 'dev') {
        imageUrlPrefix = 'https://helloava-dev.s3.us-east-2.amazonaws.com/product-feedback/';
    }
    this.setState({
      productFeedbackImageUrls: [''+imageUrlPrefix+filename]
    })
	}

  render() {
     var product = this.props.product;
      return (
        <div className="content-zone">
          <div className="product-info">
            <div className="product-img">
              <img alt={ product.name } src={ product.coverImageSource } />
            </div>
            
            <div className="product-name">{ product.name }</div>
          </div>

          <div className="rating-row">
            <div className="rating-row-title">How would you rate this product?</div>
            <div className="rating-row-conten">
              <RatingDom submitRating={this.updateRating}></RatingDom>
            </div>
          </div>

          <div className="review-label-zone">
            <div className="review-label-title">After using this product, your skin is:</div>
              <FeedbackOption submitReviewLabelData={this.submitReviewLabelData} labelData={product.productFeedbackOptionDTOList} rating = {this.state.rating}></FeedbackOption>
          </div>

          <div className="review-think-zone">
            <div className="review-think-title">Tell the community what you think</div>
            <div className="review-think-textarea-zone">
              <textarea className="review-think-textarea" onChange={this.handleInputChange} name="comment" value={this.state.comment} maxlength="150" placeholder="Share additional feedback here…"></textarea>
              
              <div className="review-upload-zone">
                <img src="/images/review/Upload.svg"></img>
                <input className="review-upload-input" onChange={(img)=>{ this.handleGetImgUploadSrc(img) }} type="file" accept = "image/*"></input>
                <div className="review-upload-title">upload</div>
              </div>

              <div className="review-upload-show-img-zone">
                <img src={this.state.showImg}></img>
              </div>

            </div>
          </div>
          <div className="submit-review-zone">
            <button className="submit-review-but" onClick={()=>{ this.handleSubmitReview()}}>
              {this.props.index < (this.props.dataLength-1) ? 'Next Product' : 'Done' }
               <Loader active={this.state.isLoader}></Loader>
            </button>
          </div>
			</div>
      )
  }
}    


// WEBPACK FOOTER //
// ./src/components/review/reviewDomItem.js